import React from 'react';
import StandardFormFields from './standard_form_fields';
import AdminFormFields from './admin_form_fields';
import {
  IProps as GenericProps,
  IRefundType,
  getInitialRefundState,
  mapRefundTypeToRefundState,
  IRefundState,
} from './refund_request';

export interface IProps extends GenericProps {
  accommodationAuthorized?: boolean;
  isAdyenShopWithPayoutsDisabled?: boolean;
  adminAbleToAccommodate?: boolean;
}

const { useState } = React;

export default function AdminRefundRequestFormFields(props: IProps) {
  const {
    userType,
    reasons,
    order,
    refundRequest,
    viewContext,
    hideRefundExplanation,
    accommodationAuthorized,
    isAdyenShopWithPayoutsDisabled,
  } = props;
  const { canConditionallyApprove } = refundRequest;

  const [refundType, setRefundType] = useState(IRefundType.FULL);
  const onRefundTypeChange = event => {
    const refundTypeValue = event.target.value;
    setRefundType(refundTypeValue);
    setRefundState(
      mapRefundTypeToRefundState(
        refundTypeValue,
        canConditionallyApprove,
      ),
    );
  };

  const initialRefundState = getInitialRefundState(canConditionallyApprove);
  const [refundState, setRefundState] = useState(initialRefundState);
  const onRefundStateChange = event => {
    const refundStateValue = event.target.value;
    const { APPROVED } = IRefundState;

    setRefundState(refundStateValue);
    if (refundStateValue !== APPROVED) {
      setIsReverbAccommodated(false);
    }
  };

  const [isReverbAccommodated, setIsReverbAccommodated] = useState(false);
  const toggleReverbAccommodated = () => {
    setIsReverbAccommodated(!isReverbAccommodated);
  };

  const [adminAccommodationReason, setAdminAccommodationReason] = useState();
  const onAdminAccommodationReasonChange = event => {
    const adminAccommodationReasonValue = event.target.value;
    setAdminAccommodationReason(adminAccommodationReasonValue);
  };

  const renderAdminFormFields = () => {
    if (accommodationAuthorized) {

      return (
        <AdminFormFields
          accommodationAuthorized={accommodationAuthorized}
          isAdyenShopWithPayoutsDisabled={isAdyenShopWithPayoutsDisabled}
          isReverbAccommodated={isReverbAccommodated}
          toggleReverbAccommodated={toggleReverbAccommodated}
          adminAccommodationReason={adminAccommodationReason}
          onAdminAccommodationReasonChange={onAdminAccommodationReasonChange}
          refundState={refundState}
        />
      );
    }
  };

  return (
    <div>
      <StandardFormFields
        userType={userType}
        reasons={reasons}
        order={order}
        refundRequest={refundRequest}
        viewContext={viewContext}
        hideRefundExplanation={hideRefundExplanation}
        refundType={refundType}
        onRefundTypeChange={onRefundTypeChange}
        refundState={refundState}
        onRefundStateChange={onRefundStateChange}
      />
      {renderAdminFormFields()}
    </div>
  );
}
